<template>
  <div>
    <div class="d-flex align-items-end">
      <h4>Formularios de declaraciones familiares</h4>
      <div class="flex-grow-1"></div>

      <button class="btn btn-primary" @click="openModal">
        <b-icon icon="file-earmark-code" font-scale="1"></b-icon>
        Crear plantilla
      </button>

    </div>
    <hr>
    <StatementTemplateList/>

    <BaseModal v-model="modalShowTemplateForm" size="xl">
      <StatementTemplateForm/>
    </BaseModal>
  </div>
</template>
<script>
import StatementTemplateForm from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementSetting/Family-statement-template-form.vue";
import StatementTemplateList from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementSetting/Family-statement-template-list.vue";
import BaseModal from "@/components/shared/Base-modal.vue";

export default {
  name: 'StatementSetting',

  components: {
    BaseModal,
    StatementTemplateForm,
    StatementTemplateList
  },

  data() {
    return {
      modalShowTemplateForm: false,
    }
  },

  methods: {
    openModal() {
      this.modalShowTemplateForm = !this.modalShowTemplateForm
    }
  },
}
</script>
